<script setup>
import { ref, defineProps, onMounted} from 'vue'

// タブ内のコンポーネント
import TabFieldGrowth from './TabFieldGrowth.vue';

const props = defineProps(['field'])
const field = ref(props.field)

// const tabFieldEvent = ref();

onMounted(() => {
  // const tabEl = document.querySelector('#cost-tab')
  // tabEl.addEventListener('shown.bs.tab', () => {
  //   tabFieldEvent.value.reloadCalendar();
  // })
})
</script>

<template>
  <div class="offcanvas-header bg-dark text-light p-2">
    <h5 class="offcanvas-title mx-auto" id="offcanvasGrowthRightLabel">{{ field?.Name }}</h5>
    <button type="button" class="btn-close text-reset btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>

  <div class="offcanvas-body p-0">
    <ul class="nav nav-fill nav-tabs" id="tabCanvas" role="tablist">
      <li class="nav-item" role="presentation">
        <button class="nav-link active px-0" id="growth-tab" data-bs-toggle="tab" data-bs-target="#growth-tab-pane" type="button" role="tab" aria-controls="growth-tab-pane" aria-selected="true">
          <i class="bi bi-clipboard-data"></i> 生育管理
        </button>
      </li>
    </ul>
    <div class="tab-content" id="tabContent">
      <div class="tab-pane h-100 fade show active" id="growth-tab-pane" role="tabpanel" aria-labelledby="growth-tab" tabindex="0">
        <TabFieldGrowth :key="field" v-bind:field="field"></TabFieldGrowth>
      </div>
    </div>
  </div>
</template>

<style scoped>
.nav-tabs{
  background-color: lavender;
}
.tab-content{
  height: 91vh;
  overflow: hidden;
}
</style>
